import React from 'react';
import { SummaryChartRange } from './SummaryChartStyles';
import { MgpGaugeChart } from '../../components/MgpGaugeChart/MgpGaugeChart';
import LoadingMask from '../../../CommonComponents/LoadingMask';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

interface Props {
  title?: string;
}

export const SummaryChartLoading: React.FC<Props> = ({ title }) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" my="16">
      {!isEmbeddedMobile && (
        <Text fontSize="h6" fontWeight={600}>
          {title}
        </Text>
      )}

      <Box display="flex">
        <Box py="16" px={isEmbeddedMobile ? '24' : '48'} display="flex" flexDirection="column">
          <Text mb="4" variant="smallCaps" fontSize="small" color="neutral.500">
            Average Return
          </Text>

          <Shimmer width="100px" height="20px" />
        </Box>
        <Box py="16" px={isEmbeddedMobile ? '24' : '48'} display="flex" flexDirection="column">
          <Text mb="4" variant="smallCaps" fontSize="small" color="neutral.500">
            Bad Timing
          </Text>

          <Shimmer width="100px" height="20px" />
        </Box>
      </Box>
      <MgpGaugeChart />
      <SummaryChartRange>
        <LoadingMask width="200px" height="20px" isDark />
      </SummaryChartRange>
    </Box>
  );
};
